export const flatten = <T>(arry: T[][]): T[] => {
  if (arry.flat != null) {
    return arry.flat()
  }
  return arry.reduce((acc, cur) => acc.concat(cur), [])
}

export const flattenOpt = <T>(arry: T[][] | undefined): T[] | undefined => {
  if (arry == null) return undefined
  return flatten(arry)
}
